import { render, staticRenderFns } from "./material-dark-projects.vue?vue&type=template&id=037cda86&scoped=true&"
import script from "./material-dark-projects.vue?vue&type=script&lang=js&"
export * from "./material-dark-projects.vue?vue&type=script&lang=js&"
import style0 from "./material-dark-projects.vue?vue&type=style&index=0&id=037cda86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037cda86",
  null
  
)

component.options.__file = "material-dark-projects.vue"
export default component.exports